/**
 * React Query keys for the rbac slice + the project-team permissions list.
 *
 * Mirrors the structure from `clario-frontend/src/services/react-query/queryKeys.ts`
 * (rbac + projectTeam.permissions sections). Kept local to this package to
 * avoid introducing a dependency on `@clarix/services-projects`, which would
 * create a cycle once that package adopts the rbac hooks itself.
 */

export const rbacQueryKeys = {
  templates: {
    all: ['rbac', 'templates'] as const,
    detail: (id: string) => ['rbac', 'templates', 'detail', id] as const,
    grantable: (scope: string) => ['rbac', 'templates', 'grantable', scope] as const,
  },
  allUserPermissions: (params?: { search?: string; template_ids?: string }) =>
    ['rbac', 'all-user-permissions', params] as const,
  userPermission: (userId: string) => ['rbac', 'user-permission', userId] as const,
  permissionMatrix: (userId: string, projectId?: string) =>
    ['rbac', 'permission-matrix', userId, projectId] as const,
  projectPermissions: (projectId: string) => ['rbac', 'project-permissions', projectId] as const,
  elevations: (filters?: Record<string, unknown>) => ['rbac', 'elevations', filters] as const,
  auditLogs: (filters?: Record<string, unknown>) => ['rbac', 'audit-logs', filters] as const,
  myPermissions: (projectId?: string) => ['rbac', 'my-permissions', projectId] as const,
} as const;

/** Project-team permission list key — colocated here because the rbac project
 * override hook needs to invalidate it. */
export const projectTeamPermissionsKey = (projectId: string) =>
  ['projectTeam', 'permissions', projectId] as const;
